import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductByIdApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = GetProductByIdApiV2Parameter & HasOnSuccess<ProductModel>;
type Props = {
    apiParameter: GetProductByIdApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterCustom: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        expand: [...(props.parameter.expand || []), "properties"],
    };
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterCustom);
